export default function CaptionImage({
  image,
  ratio = "aspect-[4/3]",
  className = "",
  dark = false,
  priority = false,
  rounded = "rounded-2xl",
}) {
  return (
    <figure className={className}>
      <div className={`overflow-hidden ${rounded} ${ratio} bg-sand`}>
        <img
          src={image.url}
          alt={image.alt}
          loading={priority ? "eager" : "lazy"}
          className="h-full w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
        />
      </div>
      {image.caption && (
        <figcaption
          className={`mt-3 flex items-start gap-3 ${dark ? "caption-on-dark" : "caption-text"}`}
        >
          <span className="mt-[7px] h-px w-6 shrink-0 bg-current" aria-hidden="true" />
          <span>{image.caption}</span>
        </figcaption>
      )}
    </figure>
  );
}
